import { useState, useEffect, lazy, Suspense } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { installNebimLicenseInterceptor } from '@/lib/nebimLicenseInterceptor';
import OfflineBanner from '@/components/OfflineBanner';
import { isNativePlatform } from '@/native/capacitor-bootstrap';
// BarcodeScanner + NebimLicenseLimitModal main bundle'a düşmemesi için lazy/dynamic
const NebimLicenseLimitModal = lazy(() =>
  import('@/components/NebimLicenseLimitModal').then(m => ({ default: m.NebimLicenseLimitModal }))
);
const Login = lazy(() => import('@/pages/Login'));
const KurulumTalep = lazy(() => import('@/pages/KurulumTalep'));
const AdminLogin = lazy(() => import('@/pages/admin/AdminLogin'));
const AdminDashboard = lazy(() => import('@/pages/admin/AdminDashboard'));
const QRLogin = lazy(() => import('@/pages/QRLogin'));
const PricingPage = lazy(() => import('@/pages/PricingPage'));
const TeknikDestekKapsam = lazy(() => import('@/pages/TeknikDestekKapsam'));
const DemoTalep = lazy(() => import('@/pages/DemoTalep'));
const Home = lazy(() => import('@/pages/Home'));
const LandingPage = lazy(() => import('@/pages/LandingPage/LandingPage'));
const LandingEditor = lazy(() => import('@/pages/admin/LandingEditor'));
const OdemeSonuc = lazy(() => import('@/pages/OdemeSonuc'));
const Scanner = lazy(() => import('@/pages/Scanner'));
const TopluSayim = lazy(() => import('@/pages/TopluSayim'));
const PublicScanner = lazy(() => import('@/pages/PublicScanner'));
const CustomerScanner = lazy(() => import('@/pages/CustomerScanner/CustomerScanner'));
const ProductDetail = lazy(() => import('@/pages/ProductDetail'));
const UrunListesi = lazy(() => import('@/pages/UrunListesi'));
const UrunEkle = lazy(() => import('@/pages/UrunEkle'));
const UrunFotografEkle = lazy(() => import('@/pages/UrunFotografEkle'));
const UrunFiyatDegistir = lazy(() => import('@/pages/UrunFiyatDegistir'));
const UrunStokEkle = lazy(() => import('@/pages/UrunStokEkle'));
const DepoIslemleri = lazy(() => import('@/pages/DepoIslemleri'));
const MagazaTransfer = lazy(() => import('@/pages/MagazaTransfer'));
const OfisTransfer = lazy(() => import('@/pages/OfisTransfer'));
const PazaryeriFinans = lazy(() => import('@/pages/PazaryeriFinans'));
const UrunMaliyet = lazy(() => import('@/pages/UrunMaliyet'));
const ReklamHarcamalari = lazy(() => import('@/pages/ReklamHarcamalari'));
const UrunStok = lazy(() => import('@/pages/UrunStok'));
const ReklamOnerileri = lazy(() => import('@/pages/ReklamOnerileri'));
const BildirimZili = lazy(() => import('@/components/BildirimZili'));
const DepolarArasi = lazy(() => import('@/pages/DepolarArasi'));
const StokEkle = lazy(() => import('@/pages/StokEkle'));
const StokCikar = lazy(() => import('@/pages/StokCikar'));
const Raporlama = lazy(() => import('@/pages/Raporlama'));
const SatisIslemleri = lazy(() => import('@/pages/SatisIslemleri'));
const OdemeSayfasi = lazy(() => import('@/pages/OdemeSayfasi'));
const GunlukSatisRaporu = lazy(() => import('@/pages/GunlukSatisRaporu'));
const GunlukSatisDetayli = lazy(() => import('@/pages/GunlukSatisDetayli'));
const UrunSatisHizi = lazy(() => import('@/pages/UrunSatisHizi'));
const HierarjiSatisRaporu = lazy(() => import('@/pages/HierarjiSatisRaporu'));
const OzellikSatisRaporu = lazy(() => import('@/pages/OzellikSatisRaporu'));
const KategoriKarsilastirma = lazy(() => import('@/pages/KategoriKarsilastirma'));
const SatilmayanUrunler = lazy(() => import('@/pages/SatilmayanUrunler'));
const Sepet = lazy(() => import('@/pages/Sepet'));
const UrunSatisAnalizi = lazy(() => import('@/pages/UrunSatisAnalizi'));
const UrunSatisAnaliziSiteBazli = lazy(() => import('@/pages/UrunSatisAnaliziSiteBazli'));
const UrunEnvanterRaporu = lazy(() => import('@/pages/UrunEnvanterRaporu'));
const UrunFiyatListesi = lazy(() => import('@/pages/UrunFiyatListesi'));
const UrunEnvanterKarsilastirmali = lazy(() => import('@/pages/UrunEnvanterKarsilastirmali'));
const UrunKarlilikRaporu = lazy(() => import('@/pages/UrunKarlilikRaporu'));
const EnCokSatanAylik = lazy(() => import('@/pages/EnCokSatanAylik'));
const EnCokSatanHaftalik = lazy(() => import('@/pages/EnCokSatanHaftalik'));
const UrunEkstreRaporu = lazy(() => import('@/pages/UrunEkstreRaporu'));
const OzelRaporlar = lazy(() => import('@/pages/OzelRaporlar'));
const OzelRaporDetay = lazy(() => import('@/pages/OzelRaporDetay'));
const PatronDashboard = lazy(() => import('@/pages/PatronDashboard'));
const Hotfixler = lazy(() => import('@/pages/Hotfixler'));
const OwnerPanel = lazy(() => import('@/pages/OwnerPanel'));
const AyarlarPatronPanel = lazy(() => import('@/pages/AyarlarPatronPanel'));
const PersonelTakibi = lazy(() => import('@/pages/PersonelTakibi'));
const PersonelEkle = lazy(() => import('@/pages/PersonelEkle'));
const PersonelGirisCikis = lazy(() => import('@/pages/PersonelGirisCikis'));
const ShiftEkle = lazy(() => import('@/pages/ShiftEkle'));
const ShiftIslemleri = lazy(() => import('@/pages/ShiftIslemleri'));
const PersonelShiftTakibi = lazy(() => import('@/pages/PersonelShiftTakibi'));
const PersonelHakedis = lazy(() => import('@/pages/PersonelHakedis'));
const IzinTalepleri = lazy(() => import('@/pages/IzinTalepleri'));
const MagazaYonetimi = lazy(() => import('@/pages/MagazaYonetimi'));
const MasrafEkle = lazy(() => import('@/pages/MasrafEkle'));
const MagazaIzinTalepleri = lazy(() => import('@/pages/MagazaIzinTalepleri'));
const PazaryeriKomisyon = lazy(() => import('@/pages/PazaryeriKomisyon'));
const AdminHome = lazy(() => import('@/pages/AdminHome'));
const Kullanicilar = lazy(() => import('@/pages/Kullanicilar'));
const Ayarlar = lazy(() => import('@/pages/Ayarlar'));
const ApiLogs = lazy(() => import('@/pages/ApiLogs'));
const DestekTalebi = lazy(() => import('@/pages/DestekTalebi'));
const TicketListesi = lazy(() => import('@/pages/TicketListesi'));
const SayimPaneli = lazy(() => import('@/pages/SayimPaneli'));
const MusteriTakip = lazy(() => import('@/pages/MusteriTakip'));
const MusteriTakipSistemi = lazy(() => import('@/pages/MusteriTakipSistemi'));
const Siparisler = lazy(() => import('@/pages/Siparisler'));
const KaraListe = lazy(() => import('@/pages/KaraListe'));
const MusteriIYS = lazy(() => import('@/pages/MusteriIYS'));
const AlisIslemleri = lazy(() => import('@/pages/AlisIslemleri'));
const SatisPOS = lazy(() => import('@/pages/SatisPOS'));
const FaturaListe = lazy(() => import('@/pages/FaturaListe'));
const SiparisFaturalastir = lazy(() => import('@/pages/SiparisFaturalastir'));
const QRBarkodYonetimi = lazy(() => import('@/pages/QRBarkodYonetimi'));
const QREtiketTaslak = lazy(() => import('@/pages/QREtiketTaslak'));
const PaketOlustur = lazy(() => import('@/pages/PaketOlustur'));
const PaketToplamaListe = lazy(() => import('@/pages/PaketToplamaListe'));
const PaketToplama = lazy(() => import('@/pages/PaketToplama'));
const PaketFaturalastir = lazy(() => import('@/pages/PaketFaturalastir'));
const PaketFaturalastirListe = lazy(() => import('@/pages/PaketFaturalastirListe'));
const PaketFaturalastirDetay = lazy(() => import('@/pages/PaketFaturalastirDetay'));
const PaketGirisi = lazy(() => import('@/pages/PaketGirisi'));
const PaketListesi = lazy(() => import('@/pages/PaketListesi'));
const PaketDetay = lazy(() => import('@/pages/PaketDetay'));
const CRM = lazy(() => import('@/pages/CRM'));
const MesajPaneli = lazy(() => import('@/pages/MesajPaneli'));
const MesajPaneliDashboard = lazy(() => import('@/pages/MesajPaneliDashboard'));
const AyarlarApi = lazy(() => import('@/pages/AyarlarApi'));
const AyarlarMail = lazy(() => import('@/pages/AyarlarMail'));
const AyarlarMagaza = lazy(() => import('@/pages/AyarlarMagaza'));
const AyarlarIYS = lazy(() => import('@/pages/AyarlarIYS'));
const AyarlarBildirimler = lazy(() => import('@/pages/AyarlarBildirimler'));
const AyarlarMesajPaneli = lazy(() => import('@/pages/AyarlarMesajPaneli'));
const AyarlarNebim = lazy(() => import('@/pages/AyarlarNebim'));
const AyarlarKargoEsleme = lazy(() => import('@/pages/AyarlarKargoEsleme'));
const KargoRetryKuyrugu = lazy(() => import('@/pages/KargoRetryKuyrugu'));
// OMS — Siparis Yonetim Sistemi (depo yonlendirme / atama)
const OMSDepoOncelikleri = lazy(() => import('@/pages/OMSDepoOncelikleri'));
const OMSRotaPaneli = lazy(() => import('@/pages/OMSRotaPaneli'));
const NebimIslemleri = lazy(() => import('@/pages/NebimIslemleri'));
const CariListesi = lazy(() => import('@/pages/CariListesi'));
const SatisFatura = lazy(() => import('@/pages/SatisFatura'));
const UrunEtiketYazdir = lazy(() => import('@/pages/UrunEtiketYazdir'));
const LabelDesigner = lazy(() => import('@/pages/LabelDesigner'));
const PayTRTest = lazy(() => import('@/pages/PayTRTest'));
const KurumsalLanding = lazy(() => import('@/pages/KurumsalLanding'));
const GiderPusulasi = lazy(() => import('@/pages/GiderPusulasi'));
const ToptanSatisLot = lazy(() => import('@/pages/ToptanSatisLot'));
const GiderTemplateEditor = lazy(() => import('@/pages/GiderTemplateEditor'));
const GiderPusulasiEditorPage = lazy(() => import('@/pages/GiderPusulasiEditorPage'));
const GiderPusulasiEditor = lazy(() => import('@/pages/GiderPusulasiEditor'));
const PerakendeSiparisFaturalastir = lazy(() => import('@/pages/PerakendeSiparisFaturalastir'));
const AktifOturumlar = lazy(() => import('@/pages/AktifOturumlar'));
const DigerSistemler = lazy(() => import('@/pages/DigerSistemler'));
const ERPDashboard = lazy(() => import('@/pages/ERPDashboard'));
const FinansmanYonetimi = lazy(() => import('@/pages/erp/FinansmanYonetimi'));
const FinansmanKodlamalar = lazy(() => import('@/pages/erp/FinansmanKodlamalar'));
const Bankalar = lazy(() => import('@/pages/erp/Bankalar'));
const BankaIslemleri = lazy(() => import('@/pages/erp/BankaIslemleri'));
const NakitKasaIslemleri = lazy(() => import('@/pages/erp/NakitKasaIslemleri'));
const AlacakHesaplari = lazy(() => import('@/pages/erp/AlacakHesaplari'));
const BorcHesaplari = lazy(() => import('@/pages/erp/BorcHesaplari'));
const PersonelMasraflari = lazy(() => import('@/pages/erp/PersonelMasraflari'));
const EFaturaIslemleri = lazy(() => import('@/pages/erp/EFaturaIslemleri'));
const EArsivIslemleri = lazy(() => import('@/pages/erp/EArsivIslemleri'));
const SatinAlma = lazy(() => import('@/pages/erp/SatinAlma'));
const SatinAlmaTeklifler = lazy(() => import('@/pages/erp/SatinAlmaTeklifler'));
const SatinAlmaToptanAlis = lazy(() => import('@/pages/erp/SatinAlmaToptanAlis'));
const SatinAlmaMasraflar = lazy(() => import('@/pages/erp/SatinAlmaMasraflar'));
const SatinAlmaMalzemeler = lazy(() => import('@/pages/erp/SatinAlmaMalzemeler'));
const SatinAlmaRaporlar = lazy(() => import('@/pages/erp/SatinAlmaRaporlar'));
const BenimMenu = lazy(() => import('@/pages/erp/BenimMenu'));
// Satış & Pazarlama
const SatisPazarlama = lazy(() => import('@/pages/erp/SatisPazarlama'));
const SatisFiyatlandirma = lazy(() => import('@/pages/erp/SatisFiyatlandirma'));
const SatisTeklifler = lazy(() => import('@/pages/erp/SatisTeklifler'));
const ToptanSatislar = lazy(() => import('@/pages/erp/ToptanSatislar'));
const MasrafSatis = lazy(() => import('@/pages/erp/MasrafSatis'));
const SatisRaporlar = lazy(() => import('@/pages/erp/SatisRaporlar'));
// Ürün Yönetimi
const UrunYonetimi = lazy(() => import('@/pages/erp/UrunYonetimi'));
const UrunYonetimKodlamalar = lazy(() => import('@/pages/erp/UrunYonetimKodlamalar'));
const Urunler = lazy(() => import('@/pages/erp/Urunler'));
const UrunleriEtiketle = lazy(() => import('@/pages/erp/UrunleriEtiketle'));
// Depo Yönetimi
const DepoYonetimi = lazy(() => import('@/pages/erp/DepoYonetimi'));
const DepoSayim = lazy(() => import('@/pages/erp/DepoSayim'));
const DepoTransfer = lazy(() => import('@/pages/erp/DepoTransfer'));
const DepoEnvanter = lazy(() => import('@/pages/erp/DepoEnvanter'));
const DepoRaporlar = lazy(() => import('@/pages/erp/DepoRaporlar'));
// Grid Sayfaları
const GUrun = lazy(() => import('@/pages/erp/grid/GUrun'));
const GBanka = lazy(() => import('@/pages/erp/grid/GBanka'));
const GBankaDetay = lazy(() => import('@/pages/erp/grid/GBankaDetay'));
const GBankaHesapTipi = lazy(() => import('@/pages/erp/grid/GBankaHesapTipi'));
const GBankaHesapTipiDetay = lazy(() => import('@/pages/erp/grid/GBankaHesapTipiDetay'));
const GBankaIslemTipi = lazy(() => import('@/pages/erp/grid/GBankaIslemTipi'));
const GBankaIslemTipiDetay = lazy(() => import('@/pages/erp/grid/GBankaIslemTipiDetay'));
const GMusteriOzellikTanimi = lazy(() => import('@/pages/erp/grid/GMusteriOzellikTanimi'));
const GMusteriOzellikTanimiDetay = lazy(() => import('@/pages/erp/grid/GMusteriOzellikTanimiDetay'));
const GMusteriOzellikleri = lazy(() => import('@/pages/erp/grid/GMusteriOzellikleri'));
const GMusteriOzellikleriDetay = lazy(() => import('@/pages/erp/grid/GMusteriOzellikleriDetay'));
const GTedarikciOzellikTanimi = lazy(() => import('@/pages/erp/grid/GTedarikciOzellikTanimi'));
const GTedarikciOzellikTanimiDetay = lazy(() => import('@/pages/erp/grid/GTedarikciOzellikTanimiDetay'));
const GTedarikciOzellikleri = lazy(() => import('@/pages/erp/grid/GTedarikciOzellikleri'));
const GTedarikciOzellikleriDetay = lazy(() => import('@/pages/erp/grid/GTedarikciOzellikleriDetay'));
const GHesapIskontoGrubu = lazy(() => import('@/pages/erp/grid/GHesapIskontoGrubu'));
const GHesapIskontoGrubuDetay = lazy(() => import('@/pages/erp/grid/GHesapIskontoGrubuDetay'));
const GKrediKartiTipi = lazy(() => import('@/pages/erp/grid/GKrediKartiTipi'));
const GKrediKartiTipiDetay = lazy(() => import('@/pages/erp/grid/GKrediKartiTipiDetay'));
const GBankaHesabi = lazy(() => import('@/pages/erp/grid/GBankaHesabi'));
const GBankaHesabiDetay = lazy(() => import('@/pages/erp/grid/GBankaHesabiDetay'));
const GNakitKasaHesabi = lazy(() => import('@/pages/erp/grid/GNakitKasaHesabi'));
const GNakitKasaHesabiDetay = lazy(() => import('@/pages/erp/grid/GNakitKasaHesabiDetay'));
// Müşteri Grid Sayfaları
const GMusteri = lazy(() => import('@/pages/erp/grid/GMusteri'));
const GMusteriDetay = lazy(() => import('@/pages/erp/grid/GMusteriDetay'));
// Tedarikçi Grid Sayfaları
const GTedarikci = lazy(() => import('@/pages/erp/grid/GTedarikci'));
const GTedarikciDetay = lazy(() => import('@/pages/erp/grid/GTedarikciDetay'));
// Fiş Sayfaları (3 Tab'lı)
const BankaAcilisFisi = lazy(() => import('@/pages/erp/fis/BankaAcilisFisi'));
const BankaParaYatirmaCekme = lazy(() => import('@/pages/erp/fis/BankaParaYatirmaCekme'));
const BankaVirmanFisi = lazy(() => import('@/pages/erp/fis/BankaVirmanFisi'));
const GelenHavaleEFT = lazy(() => import('@/pages/erp/fis/GelenHavaleEFT'));
const GonderilenHavaleEFT = lazy(() => import('@/pages/erp/fis/GonderilenHavaleEFT'));
const KasaAcilisFisi = lazy(() => import('@/pages/erp/fis/KasaAcilisFisi'));
const GKasaHareketleri = lazy(() => import('@/pages/erp/grid/GKasaHareketleri'));
const KasaHareketleriDetay = lazy(() => import('@/pages/erp/fis/KasaHareketleriDetay'));
const KasalarArasiVirman = lazy(() => import('@/pages/erp/fis/KasalarArasiVirman'));
// Müşteri ve Tedarikçi Sair Borç/Alacak Girişi
const MusteriSairBorcAlacakGirisi = lazy(() => import('@/pages/erp/fis/MusteriSairBorcAlacakGirisi'));
const TedarikciSairBorcAlacakGirisi = lazy(() => import('@/pages/erp/fis/TedarikciSairBorcAlacakGirisi'));
const BankaEkstresiRapor = lazy(() => import('@/pages/erp/rapor/BankaEkstresiRapor'));
const BankaBakiyeRapor = lazy(() => import('@/pages/erp/rapor/BankaBakiyeRapor'));
const BankaMizanRapor = lazy(() => import('@/pages/erp/rapor/BankaMizanRapor'));
const NakitKasaEkstresiRapor = lazy(() => import('@/pages/erp/rapor/NakitKasaEkstresiRapor'));
const NakitKasaMizanRapor = lazy(() => import('@/pages/erp/rapor/NakitKasaMizanRapor'));
const KasaDefteri = lazy(() => import('@/pages/erp/rapor/KasaDefteri'));
const MusteriListesi = lazy(() => import('@/pages/erp/rapor/MusteriListesi'));
const MusteriEkstresi = lazy(() => import('@/pages/erp/rapor/MusteriEkstresi'));
const MusteriMizan = lazy(() => import('@/pages/erp/rapor/MusteriMizan'));
const MusteriBakiyeRisk = lazy(() => import('@/pages/erp/rapor/MusteriBakiyeRisk'));
const TedarikciListesi = lazy(() => import('@/pages/erp/rapor/TedarikciListesi'));
const TedarikciEkstresi = lazy(() => import('@/pages/erp/rapor/TedarikciEkstresi'));
const TedarikciMizan = lazy(() => import('@/pages/erp/rapor/TedarikciMizan'));
const TedarikciBakiyeRisk = lazy(() => import('@/pages/erp/rapor/TedarikciBakiyeRisk'));
const IsAvanslariTakipListesi = lazy(() => import('@/pages/erp/rapor/IsAvanslariTakipListesi'));
const PersonelMasrafFaturasiKontrolListesi = lazy(() => import('@/pages/erp/rapor/PersonelMasrafFaturasiKontrolListesi'));
const EFaturaGelenKutusuKontrol = lazy(() => import('@/pages/erp/rapor/EFaturaGelenKutusuKontrol'));
const EFaturaGidenKutusuKontrol = lazy(() => import('@/pages/erp/rapor/EFaturaGidenKutusuKontrol'));
const EArsivFaturalariDurumRaporu = lazy(() => import('@/pages/erp/rapor/EArsivFaturalariDurumRaporu'));
const TrendyolFinance = lazy(() => import('@/pages/TrendyolFinance'));
const TicimaxFinance = lazy(() => import('@/pages/TicimaxFinance'));
const ZubizuPanel = lazy(() => import('@/pages/ZubizuPanel'));
const OtomatikSenkronizasyon = lazy(() => import('@/pages/OtomatikSenkronizasyon'));


// Protected Route Component
const ProtectedRoute = ({ user, children, allowOnlyMusteriTakip = true }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const path = window.location.pathname;

  // Yetki 6 = Müşteri Takip Sistemi'ne kısıtlı kullanıcı
  // Sadece /musteri-takip-sistemi ve /login dışındaki sayfalara erişemez
  const isMusteriTakipOnly = user.yetki === '6' || user.yetki === 6;
  if (isMusteriTakipOnly && allowOnlyMusteriTakip) {
    if (!path.startsWith('/musteri-takip-sistemi') && !path.startsWith('/login')) {
      return <Navigate to="/musteri-takip-sistemi" replace />;
    }
  }

  // Yetki 5 = Patron Paneli 2 (SP tabanlı OwnerPanel) — sadece /patron-paneli, /raporlama,
  // /toplu-sayim ve alt yollarına erişebilir
  const isPatronPaneli2Only = user.yetki === '5' || user.yetki === 5;
  if (isPatronPaneli2Only) {
    // İzinli path prefixler
    const allowed = ['/patron-paneli', '/raporlama', '/toplu-sayim', '/mesaj-paneli', '/login'];
    if (!allowed.some(p => path.startsWith(p))) {
      return <Navigate to="/patron-paneli" replace />;
    }
  }

  return children;
};

function App() {
  const [scannedProduct, setScannedProduct] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userPermissions, setUserPermissions] = useState([]);

  // Global fetch interceptor'ı bir kez kur — Nebim V3 lisans limit popup için
  useEffect(() => {
    installNebimLicenseInterceptor();
  }, []);

  // Check for existing user session on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        // Yetki 3 ise izinleri yükle
        if (parsedUser.yetki === '3' || parsedUser.yetki === 3) {
          fetchUserPermissions(parsedUser);
        }
      } catch (err) {
        console.error('Error parsing stored user:', err);
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  // Kullanıcı girişi sonrası Dynamsoft SDK'yı arka planda ön-yükle (dynamic import — main bundle'a düşmesin)
  // ⚠️ ÖNEMLİ: Native Capacitor (Android APK / iOS) üzerinde Dynamsoft SDK YÜKLENMEZ.
  // Sebep: Capacitor Android WebView origin'i `https://localhost` — Dynamsoft'un
  // lisans doğrulaması bu domaine izin vermez ve 24-hour trial'a düşer. Trial biter
  // bitmez SDK global "Temporary license expired" popup'ını Patron Paneli üzerinde
  // gösterir. Native scanner ihtiyaçları için `NativeBarcodeScanner` (Google MLKit,
  // ücretsiz) ve `html5-qrcode` (SatisFatura, PaketFaturalastırDetay) zaten kullanılıyor.
  useEffect(() => {
    if (user && !isNativePlatform()) {
      import('@/components/BarcodeScanner')
        .then(m => m.preloadBarcodeSDK && m.preloadBarcodeSDK().catch(() => {}))
        .catch(() => {});
    }
  }, [user]);

  const fetchUserPermissions = async (userData) => {
    try {
      const baseUrl = window.location.origin;
      const token = localStorage.getItem('token');
      
      const response = await fetch(
        `${baseUrl}/api/users/permissions/${userData.username}?company_name=${userData.companyName}`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      
      const data = await response.json();
      if (data.success && data.permissions) {
        setUserPermissions(data.permissions);
        console.log('Kullanıcı izinleri:', data.permissions);
      }
    } catch (error) {
      console.error('İzinler yüklenemedi:', error);
    }
  };

  const handleLogin = async (userData) => {
    setUser(userData);
    // Yetki 3 ise izinleri yükle
    if (userData.yetki === '3' || userData.yetki === 3) {
      await fetchUserPermissions(userData);
    }
  };

  const handleLogout = async () => {
    try {
      // Session'ı backend'den sil
      const { authAPI } = await import('./services/api');
      await authAPI.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Local state'i temizle
      setUser(null);
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('session_id');

      // Platform cache'i de temizle (sonraki kullanici eski veriyi gormesin)
      try {
        const { platformCache } = await import('./utils/platformCache');
        platformCache.clear();
      } catch (_e) { /* sessizce gec */ }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 flex items-center justify-center">
        <div className="text-white text-xl">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900">
      {/* Offline banner — network kesildiğinde üstte kırmızı bar gösterir */}
      <OfflineBanner />
      {/* Sonner toast Provider — toast.success/error cagrilari icin gerekli */}
      <Toaster position="top-right" richColors closeButton theme="dark" />
      {/* Nebim V3 lisans limit hatası popup — lazy, sadece hata olunca yüklenir */}
      <Suspense fallback={null}>
        <NebimLicenseLimitModal />
      </Suspense>
      <BrowserRouter>
        {/* Uygulama ici bildirim merkezi (yeni transfer emri vb.) */}
        {user && (
          <Suspense fallback={null}>
            <BildirimZili user={user} />
          </Suspense>
        )}
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900">
            <div className="w-10 h-10 border-4 border-white/20 border-t-white rounded-full animate-spin" />
          </div>
        }>
        <Routes>
          <Route
            path="/preview-landing"
            element={<LandingPage />}
          />
          <Route 
            path="/login" 
            element={user ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />} 
          />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/landing" element={<LandingEditor />} />
          <Route path="/kurulum-talep" element={<KurulumTalep />} />
          <Route path="/odeme-sonuc" element={<OdemeSonuc />} />
          <Route path="/index.php" element={<OdemeSonuc />} />
          <Route 
            path="/pricing" 
            element={isNativePlatform() ? <Navigate to="/" replace /> : <PricingPage />} 
          />
          <Route 
            path="/teknik-destek-kapsam" 
            element={<TeknikDestekKapsam />} 
          />
          <Route 
            path="/sepet" 
            element={<Sepet />} 
          />
          <Route 
            path="/demo-talep" 
            element={<DemoTalep />} 
          />
          <Route 
            path="/diger-sistemler" 
            element={<DigerSistemler />} 
          />
          <Route 
            path="/kurumsal" 
            element={<KurumsalLanding />} 
          />
          <Route 
            path="/qr/:code" 
            element={<QRLogin setUser={setUser} setScannedProduct={setScannedProduct} />} 
          />
          <Route 
            path="/" 
            element={
              <ProtectedRoute user={user}>
                <Home user={user} userPermissions={userPermissions} onLogout={handleLogout} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute user={user}>
                <AdminHome user={user} userPermissions={userPermissions} onLogout={handleLogout} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/scanner" 
            element={
              <ProtectedRoute user={user}>
                <Scanner user={user} setScannedProduct={setScannedProduct} scannedProduct={scannedProduct} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/toplu-sayim" 
            element={
              <ProtectedRoute user={user}>
                <TopluSayim user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/scanner/:companyName/:companyCode" 
            element={<PublicScanner />} 
          />
          <Route 
            path="/customerscanner/:companyName/:warehouseCode" 
            element={<CustomerScanner />} 
          />
          <Route 
            path="/customerscanner/:companyName/:officeCode/:storeCode/:warehouseCode" 
            element={<CustomerScanner />} 
          />
          <Route 
            path="/product-detail" 
            element={
              <ProtectedRoute user={user}>
                <ProductDetail user={user} product={scannedProduct} setScannedProduct={setScannedProduct} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/urun-listesi" 
            element={
              <ProtectedRoute user={user}>
                <UrunListesi userPermissions={userPermissions} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/urun-ekle" 
            element={
              <ProtectedRoute user={user}>
                <UrunEkle user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/urun-fotograf-ekle" 
            element={
              <ProtectedRoute user={user}>
                <UrunFotografEkle user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/urun-fiyat-degistir" 
            element={
              <ProtectedRoute user={user}>
                <UrunFiyatDegistir user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/urun-stok-ekle" 
            element={
              <ProtectedRoute user={user}>
                <UrunStokEkle user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/depo-islemleri" 
            element={
              <ProtectedRoute user={user}>
                <DepoIslemleri userPermissions={userPermissions} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/depo-islemleri/magaza-transfer" 
            element={
              <ProtectedRoute user={user}>
                <MagazaTransfer user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/depo-islemleri/ofis-transfer" 
            element={
              <ProtectedRoute user={user}>
                <OfisTransfer user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/finans-yonetimi" 
            element={
              <ProtectedRoute user={user}>
                <PazaryeriFinans user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/urun-maliyet" 
            element={
              <ProtectedRoute user={user}>
                <UrunMaliyet user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/reklam-harcamalari" 
            element={
              <ProtectedRoute user={user}>
                <ReklamHarcamalari user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/urun-stok" 
            element={
              <ProtectedRoute user={user}>
                <UrunStok user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/reklam-onerileri" 
            element={
              <ProtectedRoute user={user}>
                <ReklamOnerileri user={user} />
              </ProtectedRoute>
            } 
          />
          {/* Eski adres — kayitli link/bookmark 404 gormesin diye
              /finans-yonetimi'ne yonlendirilir. */}
          <Route 
            path="/pazaryeri-finans" 
            element={<Navigate to="/finans-yonetimi" replace />} 
          />
          <Route 
            path="/depo-islemleri/depolar-arasi" 
            element={
              <ProtectedRoute user={user}>
                <DepolarArasi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/depo-islemleri/stok-ekle" 
            element={
              <ProtectedRoute user={user}>
                <StokEkle user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/depo-islemleri/stok-cikar" 
            element={
              <ProtectedRoute user={user}>
                <StokCikar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama" 
            element={
              <ProtectedRoute user={user}>
                <Raporlama userPermissions={userPermissions} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis-islemleri" 
            element={
              <ProtectedRoute user={user}>
                <SatisIslemleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/qr-barkod" 
            element={
              <ProtectedRoute user={user}>
                <QRBarkodYonetimi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/qr-etiket-taslak" 
            element={
              <ProtectedRoute user={user}>
                <QREtiketTaslak user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/paket-olustur" 
            element={
              <ProtectedRoute user={user}>
                <PaketOlustur user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-olustur" 
            element={
              <ProtectedRoute user={user}>
                <PaketOlustur user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/toptan-satis-lot" 
            element={
              <ProtectedRoute user={user}>
                <ToptanSatisLot user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-toplama" 
            element={
              <ProtectedRoute user={user}>
                <PaketToplamaListe user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-toplama-detay/:paketId" 
            element={
              <ProtectedRoute user={user}>
                <PaketToplama user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-faturalastir" 
            element={
              <ProtectedRoute user={user}>
                <PaketFaturalastirListe user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-faturalastir-detay/:paketId" 
            element={
              <ProtectedRoute user={user}>
                <PaketFaturalastirDetay user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-faturalastir-legacy" 
            element={
              <ProtectedRoute user={user}>
                <PaketGirisi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-listesi" 
            element={
              <ProtectedRoute user={user}>
                <PaketListesi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/paket-detay/:paketId" 
            element={
              <ProtectedRoute user={user}>
                <PaketDetay user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/alis-islemleri" 
            element={
              <ProtectedRoute user={user}>
                <AlisIslemleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/:tip/yeni" 
            element={
              <ProtectedRoute user={user}>
                <SatisPOS user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/:tip/liste" 
            element={
              <ProtectedRoute user={user}>
                <FaturaListe user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/alis/:tip/yeni" 
            element={
              <ProtectedRoute user={user}>
                <SatisPOS user={user} isAlis={true} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/alis/:tip/liste" 
            element={
              <ProtectedRoute user={user}>
                <FaturaListe user={user} isAlis={true} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/crm" 
            element={
              <ProtectedRoute user={user}>
                <CRM user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/mesaj-paneli" 
            element={
              <ProtectedRoute user={user}>
                <MesajPaneliDashboard user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/mesaj-paneli/chat" 
            element={
              <ProtectedRoute user={user}>
                <MesajPaneli user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/trendyol-finance" 
            element={
              <ProtectedRoute user={user}>
                <TrendyolFinance user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ticimax-finance" 
            element={
              <ProtectedRoute user={user}>
                <TicimaxFinance user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/otomatik-senkronizasyon" 
            element={
              <ProtectedRoute user={user}>
                <OtomatikSenkronizasyon user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/zubizu-panel" 
            element={
              <ProtectedRoute user={user}>
                <ZubizuPanel user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/siparis/faturalastir" 
            element={
              <ProtectedRoute user={user}>
                <SiparisFaturalastir />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis/iade/urun" 
            element={
              <ProtectedRoute user={user}>
                <SiparisFaturalastir isIade={true} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/alis/siparis/faturalastir" 
            element={
              <ProtectedRoute user={user}>
                <SiparisFaturalastir isAlis={true} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/alis/iade/urun" 
            element={
              <ProtectedRoute user={user}>
                <SiparisFaturalastir isIade={true} isAlis={true} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/satis-islemleri/odeme" 
            element={
              <ProtectedRoute user={user}>
                <OdemeSayfasi />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/gunluk-satis" 
            element={
              <ProtectedRoute user={user}>
                <GunlukSatisRaporu />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/urun-analiz" 
            element={
              <ProtectedRoute user={user}>
                <UrunSatisAnalizi />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/urun-analiz-site-bazli" 
            element={
              <ProtectedRoute user={user}>
                <UrunSatisAnaliziSiteBazli />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/ozel-raporlar" 
            element={
              <ProtectedRoute user={user}>
                <OzelRaporlar />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/ozel-rapor/:spName" 
            element={
              <ProtectedRoute user={user}>
                <OzelRaporDetay />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/patron-dashboard" 
            element={
              <ProtectedRoute user={user}>
                <PatronDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/hotfixler" 
            element={
              <ProtectedRoute user={user}>
                <Hotfixler />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/patron-paneli" 
            element={
              <ProtectedRoute user={user}>
                <OwnerPanel />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/patron-paneli" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarPatronPanel />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/envanter" 
            element={
              <ProtectedRoute user={user}>
                <UrunEnvanterRaporu />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/urun-fiyat-listesi" 
            element={
              <ProtectedRoute user={user}>
                <UrunFiyatListesi />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/envanter-karsilastirmali" 
            element={
              <ProtectedRoute user={user}>
                <UrunEnvanterKarsilastirmali />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/karlilik" 
            element={
              <ProtectedRoute user={user}>
                <UrunKarlilikRaporu />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/aylik-coksatan" 
            element={
              <ProtectedRoute user={user}>
                <EnCokSatanAylik />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/haftalik-coksatan" 
            element={
              <ProtectedRoute user={user}>
                <EnCokSatanHaftalik />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/gunluk-satis-detayli" 
            element={
              <ProtectedRoute user={user}>
                <GunlukSatisDetayli />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/urun-satis-hizi" 
            element={
              <ProtectedRoute user={user}>
                <UrunSatisHizi />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/urun-ekstre" 
            element={
              <ProtectedRoute user={user}>
                <UrunEkstreRaporu />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/hierarji-satis" 
            element={
              <ProtectedRoute user={user}>
                <HierarjiSatisRaporu />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/ozellik-satis" 
            element={
              <ProtectedRoute user={user}>
                <OzellikSatisRaporu />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/kategori-karsilastirma" 
            element={
              <ProtectedRoute user={user}>
                <KategoriKarsilastirma />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/raporlama/satilmayan-urunler" 
            element={
              <ProtectedRoute user={user}>
                <SatilmayanUrunler />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/personel-takibi" 
            element={
              <ProtectedRoute user={user}>
                <PersonelTakibi userPermissions={userPermissions} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/magaza-yonetimi/personel-ekle" 
            element={
              <ProtectedRoute user={user}>
                <PersonelEkle user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/magaza-yonetimi/shift-ekle" 
            element={
              <ProtectedRoute user={user}>
                <ShiftEkle user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/magaza-yonetimi/shift-takibi" 
            element={
              <ProtectedRoute user={user}>
                <PersonelShiftTakibi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/personel-takibi/giris-cikis" 
            element={
              <ProtectedRoute user={user}>
                <PersonelGirisCikis user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/personel-takibi/shift-islemleri" 
            element={
              <ProtectedRoute user={user}>
                <ShiftIslemleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/personel-takibi/hakedis" 
            element={
              <ProtectedRoute user={user}>
                <PersonelHakedis user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/personel-takibi/izin-talepleri" 
            element={
              <ProtectedRoute user={user}>
                <IzinTalepleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/magaza-yonetimi" 
            element={
              <ProtectedRoute user={user}>
                <MagazaYonetimi userPermissions={userPermissions} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/magaza-yonetimi/masraf-ekle" 
            element={
              <ProtectedRoute user={user}>
                <MasrafEkle user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/magaza-yonetimi/izin-talepleri" 
            element={
              <ProtectedRoute user={user}>
                <MagazaIzinTalepleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/pazaryeri-komisyon" 
            element={
              <ProtectedRoute user={user}>
                <PazaryeriKomisyon user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/kullanicilar" 
            element={
              <ProtectedRoute user={user}>
                <Ayarlar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar" 
            element={
              <ProtectedRoute user={user}>
                <Ayarlar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/kullanicilar-yonetimi" 
            element={
              <ProtectedRoute user={user}>
                <Kullanicilar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/api" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarApi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/mail" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarMail user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/magaza" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarMagaza user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/iys" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarIYS user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/bildirimler" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarBildirimler user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/mesaj-paneli" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarMesajPaneli user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/nebim" 
            element={
              <ProtectedRoute user={user}>
                <AyarlarNebim user={user} />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/ayarlar/kargo-esleme"
            element={
              <ProtectedRoute user={user}>
                <AyarlarKargoEsleme user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kargo/retry-kuyrugu"
            element={
              <ProtectedRoute user={user}>
                <KargoRetryKuyrugu user={user} />
              </ProtectedRoute>
            }
          />
          {/* OMS — Sipariş Yönetim Sistemi */}
          <Route
            path="/oms/depo-oncelikleri"
            element={
              <ProtectedRoute user={user}>
                <OMSDepoOncelikleri user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/oms/rota-paneli"
            element={
              <ProtectedRoute user={user}>
                <OMSRotaPaneli user={user} />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/nebim-islemleri" 
            element={
              <ProtectedRoute user={user}>
                <NebimIslemleri user={user} userPermissions={userPermissions} />
              </ProtectedRoute>
            } 
          />
          {/* Cari Yönetimi — Müşteri / Tedarikçi ayrı ekran (tab yok, tip route ile sabit) */}
          <Route 
            path="/musteriler" 
            element={
              <ProtectedRoute user={user}>
                <CariListesi user={user} cariTypeKey="TOPTAN" />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/tedarikciler" 
            element={
              <ProtectedRoute user={user}>
                <CariListesi user={user} cariTypeKey="TEDARIKCI" />
              </ProtectedRoute>
            } 
          />
          {/* Fatura Oluştur — /fatura-olustur/satis veya /fatura-olustur/alis */}
          <Route
            path="/fatura-olustur/:tip"
            element={
              <ProtectedRoute user={user}>
                <SatisFatura user={user} />
              </ProtectedRoute>
            }
          />
          {/* Sipariş Oluştur — /siparis-olustur/satis-siparis veya /siparis-olustur/alis-siparis
              Aynı wizard (SatisFatura), ModelType farklı (4/14), endpoint Satis-Order-Create */}
          <Route
            path="/siparis-olustur/:tip"
            element={
              <ProtectedRoute user={user}>
                <SatisFatura user={user} />
              </ProtectedRoute>
            }
          />
          {/* İrsaliye Oluştur — /irsaliye-olustur/satis-irsaliye veya /irsaliye-olustur/alis-irsaliye
              Aynı wizard, ModelType farklı (3/13), endpoint Satis-Shipment-Create */}
          <Route
            path="/irsaliye-olustur/:tip"
            element={
              <ProtectedRoute user={user}>
                <SatisFatura user={user} />
              </ProtectedRoute>
            }
          />
          <Route 
            path="/urun-etiket-yazdir" 
            element={
              <ProtectedRoute user={user}>
                <UrunEtiketYazdir user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/etiket-tasarla" 
            element={
              <ProtectedRoute user={user}>
                <LabelDesigner user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/paytr-test" 
            element={
              <ProtectedRoute user={user}>
                <PayTRTest user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/gider-pusulasi" 
            element={
              <ProtectedRoute user={user}>
                <GiderPusulasi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/gider-pusulasi-editor" 
            element={
              <ProtectedRoute user={user}>
                <GiderPusulasiEditorPage user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/gider-pusulasi-editor-v2" 
            element={
              <ProtectedRoute user={user}>
                <GiderPusulasiEditor user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/perakende-siparis-faturalastir" 
            element={
              <ProtectedRoute user={user}>
                <PerakendeSiparisFaturalastir user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/gider-sablonlari" 
            element={
              <ProtectedRoute user={user}>
                <GiderTemplateEditor user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ayarlar/aktif-oturumlar" 
            element={
              <ProtectedRoute user={user}>
                <AktifOturumlar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp" 
            element={
              <ProtectedRoute user={user}>
                <ERPDashboard user={user} onLogout={handleLogout} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman" 
            element={
              <ProtectedRoute user={user}>
                <FinansmanYonetimi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/kodlamalar" 
            element={
              <ProtectedRoute user={user}>
                <FinansmanKodlamalar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/bankalar" 
            element={
              <ProtectedRoute user={user}>
                <Bankalar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/banka-islemleri" 
            element={
              <ProtectedRoute user={user}>
                <BankaIslemleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/nakit-kasa" 
            element={
              <ProtectedRoute user={user}>
                <NakitKasaIslemleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/alacak-hesaplari" 
            element={
              <ProtectedRoute user={user}>
                <AlacakHesaplari user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/borc-hesaplari" 
            element={
              <ProtectedRoute user={user}>
                <BorcHesaplari user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/personel-masraflari" 
            element={
              <ProtectedRoute user={user}>
                <PersonelMasraflari user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/e-fatura" 
            element={
              <ProtectedRoute user={user}>
                <EFaturaIslemleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/finansman/e-arsiv" 
            element={
              <ProtectedRoute user={user}>
                <EArsivIslemleri user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satin-alma" 
            element={
              <ProtectedRoute user={user}>
                <SatinAlma user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satin-alma/teklifler" 
            element={
              <ProtectedRoute user={user}>
                <SatinAlmaTeklifler user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satin-alma/toptan-alis" 
            element={
              <ProtectedRoute user={user}>
                <SatinAlmaToptanAlis user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satin-alma/masraflar" 
            element={
              <ProtectedRoute user={user}>
                <SatinAlmaMasraflar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satin-alma/malzemeler" 
            element={
              <ProtectedRoute user={user}>
                <SatinAlmaMalzemeler user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satin-alma/raporlar" 
            element={
              <ProtectedRoute user={user}>
                <SatinAlmaRaporlar user={user} />
              </ProtectedRoute>
            } 
          />
          {/* Satış & Pazarlama Routes */}
          <Route 
            path="/erp/satis-pazarlama" 
            element={
              <ProtectedRoute user={user}>
                <SatisPazarlama user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satis-pazarlama/fiyatlandirma" 
            element={
              <ProtectedRoute user={user}>
                <SatisFiyatlandirma user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satis-pazarlama/teklifler" 
            element={
              <ProtectedRoute user={user}>
                <SatisTeklifler user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satis-pazarlama/toptan-satislar" 
            element={
              <ProtectedRoute user={user}>
                <ToptanSatislar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satis-pazarlama/masraf-satis" 
            element={
              <ProtectedRoute user={user}>
                <MasrafSatis user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/satis-pazarlama/raporlar" 
            element={
              <ProtectedRoute user={user}>
                <SatisRaporlar user={user} />
              </ProtectedRoute>
            } 
          />
          {/* Ürün Yönetimi Routes */}
          <Route 
            path="/erp/urun-yonetimi" 
            element={
              <ProtectedRoute user={user}>
                <UrunYonetimi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/urun-yonetimi/kodlamalar" 
            element={
              <ProtectedRoute user={user}>
                <UrunYonetimKodlamalar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/urun-yonetimi/urunler" 
            element={
              <ProtectedRoute user={user}>
                <Urunler user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/urun-yonetimi/etiketle" 
            element={
              <ProtectedRoute user={user}>
                <UrunleriEtiketle user={user} />
              </ProtectedRoute>
            } 
          />
          {/* Grid Sayfaları */}
          <Route 
            path="/erp/g/urun" 
            element={
              <ProtectedRoute user={user}>
                <GUrun user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka" 
            element={
              <ProtectedRoute user={user}>
                <GBanka user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka/detay" 
            element={
              <ProtectedRoute user={user}>
                <GBankaDetay user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka/detay/:id" 
            element={
              <ProtectedRoute user={user}>
                <GBankaDetay user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka-hesap-tipi" 
            element={
              <ProtectedRoute user={user}>
                <GBankaHesapTipi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka-hesap-tipi/detay" 
            element={
              <ProtectedRoute user={user}>
                <GBankaHesapTipiDetay user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka-hesap-tipi/detay/:id" 
            element={
              <ProtectedRoute user={user}>
                <GBankaHesapTipiDetay user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka-islem-tipi" 
            element={
              <ProtectedRoute user={user}>
                <GBankaIslemTipi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka-islem-tipi/detay" 
            element={
              <ProtectedRoute user={user}>
                <GBankaIslemTipiDetay user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/g/banka-islem-tipi/detay/:id" 
            element={
              <ProtectedRoute user={user}>
                <GBankaIslemTipiDetay user={user} />
              </ProtectedRoute>
            } 
          />
          {/* Müşteri Özellik Tanımı */}
          <Route path="/erp/g/musteri-ozellik-tanimi" element={<ProtectedRoute user={user}><GMusteriOzellikTanimi user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/musteri-ozellik-tanimi/detay" element={<ProtectedRoute user={user}><GMusteriOzellikTanimiDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/musteri-ozellik-tanimi/detay/:id" element={<ProtectedRoute user={user}><GMusteriOzellikTanimiDetay user={user} /></ProtectedRoute>} />
          {/* Müşteri Özellikleri */}
          <Route path="/erp/g/musteri-ozellikleri" element={<ProtectedRoute user={user}><GMusteriOzellikleri user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/musteri-ozellikleri/detay" element={<ProtectedRoute user={user}><GMusteriOzellikleriDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/musteri-ozellikleri/detay/:id" element={<ProtectedRoute user={user}><GMusteriOzellikleriDetay user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Özellik Tanımı */}
          <Route path="/erp/g/tedarikci-ozellik-tanimi" element={<ProtectedRoute user={user}><GTedarikciOzellikTanimi user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/tedarikci-ozellik-tanimi/detay" element={<ProtectedRoute user={user}><GTedarikciOzellikTanimiDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/tedarikci-ozellik-tanimi/detay/:id" element={<ProtectedRoute user={user}><GTedarikciOzellikTanimiDetay user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Özellikleri */}
          <Route path="/erp/g/tedarikci-ozellikleri" element={<ProtectedRoute user={user}><GTedarikciOzellikleri user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/tedarikci-ozellikleri/detay" element={<ProtectedRoute user={user}><GTedarikciOzellikleriDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/tedarikci-ozellikleri/detay/:id" element={<ProtectedRoute user={user}><GTedarikciOzellikleriDetay user={user} /></ProtectedRoute>} />
          {/* Hesap İskonto Grubu - Kaldırıldı ama route'lar duruyor (eski linkler için) */}
          <Route path="/erp/g/hesap-iskonto-grubu" element={<ProtectedRoute user={user}><GHesapIskontoGrubu user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/hesap-iskonto-grubu/detay" element={<ProtectedRoute user={user}><GHesapIskontoGrubuDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/hesap-iskonto-grubu/detay/:id" element={<ProtectedRoute user={user}><GHesapIskontoGrubuDetay user={user} /></ProtectedRoute>} />
          {/* Kredi Kartı Tipi */}
          <Route path="/erp/g/kredi-karti-tipi" element={<ProtectedRoute user={user}><GKrediKartiTipi user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/kredi-karti-tipi/detay" element={<ProtectedRoute user={user}><GKrediKartiTipiDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/kredi-karti-tipi/detay/:id" element={<ProtectedRoute user={user}><GKrediKartiTipiDetay user={user} /></ProtectedRoute>} />
          {/* Banka Hesabı */}
          <Route path="/erp/g/banka-hesabi" element={<ProtectedRoute user={user}><GBankaHesabi user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/banka-hesabi/detay" element={<ProtectedRoute user={user}><GBankaHesabiDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/banka-hesabi/detay/:id" element={<ProtectedRoute user={user}><GBankaHesabiDetay user={user} /></ProtectedRoute>} />
          {/* Nakit Kasa Hesabı Grid */}
          <Route path="/erp/g/nakit-kasa-hesabi" element={<ProtectedRoute user={user}><GNakitKasaHesabi user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/nakit-kasa-hesabi/detay" element={<ProtectedRoute user={user}><GNakitKasaHesabiDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/nakit-kasa-hesabi/detay/:id" element={<ProtectedRoute user={user}><GNakitKasaHesabiDetay user={user} /></ProtectedRoute>} />
          {/* Müşteri Grid */}
          <Route path="/erp/g/musteri" element={<ProtectedRoute user={user}><GMusteri user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/musteri/detay" element={<ProtectedRoute user={user}><GMusteriDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/musteri/detay/:id" element={<ProtectedRoute user={user}><GMusteriDetay user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Grid */}
          <Route path="/erp/g/tedarikci" element={<ProtectedRoute user={user}><GTedarikci user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/tedarikci/detay" element={<ProtectedRoute user={user}><GTedarikciDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/g/tedarikci/detay/:id" element={<ProtectedRoute user={user}><GTedarikciDetay user={user} /></ProtectedRoute>} />
          {/* Banka Açılış Fişi (3-Tab Form) */}
          <Route path="/erp/3/banka-acilis-fisi" element={<ProtectedRoute user={user}><BankaAcilisFisi user={user} /></ProtectedRoute>} />
          {/* Banka Para Yatırma / Çekme (3-Tab Form) */}
          <Route path="/erp/3/banka-para-yatirma-cekme" element={<ProtectedRoute user={user}><BankaParaYatirmaCekme user={user} /></ProtectedRoute>} />
          {/* Banka Virman Fişi (3-Tab Form) */}
          <Route path="/erp/3/banka-virman-fisi" element={<ProtectedRoute user={user}><BankaVirmanFisi user={user} /></ProtectedRoute>} />
          {/* Gelen Havale / EFT (3-Tab Form) */}
          <Route path="/erp/3/gelen-havale-eft" element={<ProtectedRoute user={user}><GelenHavaleEFT user={user} /></ProtectedRoute>} />
          {/* Gönderilen Havale / EFT (3-Tab Form) */}
          <Route path="/erp/3/gonderilen-havale-eft" element={<ProtectedRoute user={user}><GonderilenHavaleEFT user={user} /></ProtectedRoute>} />
          {/* Kasa Açılış Fişi (3-Tab Form) */}
          <Route path="/erp/3/kasa-acilis-fisi" element={<ProtectedRoute user={user}><KasaAcilisFisi user={user} /></ProtectedRoute>} />
          {/* Kasa Hareketleri Grid */}
          <Route path="/erp/g/kasa-hareketleri" element={<ProtectedRoute user={user}><GKasaHareketleri user={user} /></ProtectedRoute>} />
          {/* Kasa Hareketleri Detay (3-Tab Form) */}
          <Route path="/erp/3/kasa-hareketleri/detay" element={<ProtectedRoute user={user}><KasaHareketleriDetay user={user} /></ProtectedRoute>} />
          <Route path="/erp/3/kasa-hareketleri/detay/:id" element={<ProtectedRoute user={user}><KasaHareketleriDetay user={user} /></ProtectedRoute>} />
          {/* Kasalar Arası Virman */}
          <Route path="/erp/3/kasalar-arasi-virman" element={<ProtectedRoute user={user}><KasalarArasiVirman user={user} /></ProtectedRoute>} />
          {/* Müşteri Sair Borç/Alacak Girişi */}
          <Route path="/erp/3/musteri-sair-borc-alacak" element={<ProtectedRoute user={user}><MusteriSairBorcAlacakGirisi user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Sair Borç/Alacak Girişi */}
          <Route path="/erp/3/tedarikci-sair-borc-alacak" element={<ProtectedRoute user={user}><TedarikciSairBorcAlacakGirisi user={user} /></ProtectedRoute>} />
          {/* Banka Ekstresi Raporu */}
          <Route path="/erp/rapor/banka-ekstresi" element={<ProtectedRoute user={user}><BankaEkstresiRapor user={user} /></ProtectedRoute>} />
          {/* Banka Bakiye Raporu */}
          <Route path="/erp/rapor/banka-bakiye" element={<ProtectedRoute user={user}><BankaBakiyeRapor user={user} /></ProtectedRoute>} />
          {/* Banka Mizan Raporu */}
          <Route path="/erp/rapor/banka-mizan" element={<ProtectedRoute user={user}><BankaMizanRapor user={user} /></ProtectedRoute>} />
          {/* Nakit Kasa Ekstresi Raporu */}
          <Route path="/erp/rapor/nakit-kasa-ekstresi" element={<ProtectedRoute user={user}><NakitKasaEkstresiRapor user={user} /></ProtectedRoute>} />
          {/* Nakit Kasa Mizan Raporu */}
          <Route path="/erp/rapor/nakit-kasa-mizan" element={<ProtectedRoute user={user}><NakitKasaMizanRapor user={user} /></ProtectedRoute>} />
          {/* Kasa Defteri */}
          <Route path="/erp/rapor/kasa-defteri" element={<ProtectedRoute user={user}><KasaDefteri user={user} /></ProtectedRoute>} />
          {/* Müşteri Listesi Raporu */}
          <Route path="/erp/rapor/musteri-listesi" element={<ProtectedRoute user={user}><MusteriListesi user={user} /></ProtectedRoute>} />
          {/* Müşteri Ekstresi Raporu */}
          <Route path="/erp/rapor/musteri-ekstresi" element={<ProtectedRoute user={user}><MusteriEkstresi user={user} /></ProtectedRoute>} />
          {/* Müşteri Mizan Raporu */}
          <Route path="/erp/rapor/musteri-mizan" element={<ProtectedRoute user={user}><MusteriMizan user={user} /></ProtectedRoute>} />
          {/* Müşteri Bakiye ve Risk Raporu */}
          <Route path="/erp/rapor/musteri-bakiye-risk" element={<ProtectedRoute user={user}><MusteriBakiyeRisk user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Listesi Raporu */}
          <Route path="/erp/rapor/tedarikci-listesi" element={<ProtectedRoute user={user}><TedarikciListesi user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Ekstresi Raporu */}
          <Route path="/erp/rapor/tedarikci-ekstresi" element={<ProtectedRoute user={user}><TedarikciEkstresi user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Mizan Raporu */}
          <Route path="/erp/rapor/tedarikci-mizan" element={<ProtectedRoute user={user}><TedarikciMizan user={user} /></ProtectedRoute>} />
          {/* Tedarikçi Bakiye ve Risk Raporu */}
          <Route path="/erp/rapor/tedarikci-bakiye-risk" element={<ProtectedRoute user={user}><TedarikciBakiyeRisk user={user} /></ProtectedRoute>} />
          {/* İş Avansları Takip Listesi */}
          <Route path="/erp/rapor/is-avanslari-takip-listesi" element={<ProtectedRoute user={user}><IsAvanslariTakipListesi user={user} /></ProtectedRoute>} />
          {/* Personel Masraf Faturası Kontrol Listesi */}
          <Route path="/erp/rapor/personel-masraf-faturasi-kontrol" element={<ProtectedRoute user={user}><PersonelMasrafFaturasiKontrolListesi user={user} /></ProtectedRoute>} />
          {/* E-Fatura Gelen Kutusu Kontrol Raporu */}
          <Route path="/erp/rapor/e-fatura-gelen-kutusu-kontrol" element={<ProtectedRoute user={user}><EFaturaGelenKutusuKontrol user={user} /></ProtectedRoute>} />
          {/* E-Fatura Giden Kutusu Kontrol Raporu */}
          <Route path="/erp/rapor/e-fatura-giden-kutusu-kontrol" element={<ProtectedRoute user={user}><EFaturaGidenKutusuKontrol user={user} /></ProtectedRoute>} />
          {/* E-Arşiv Faturaları Durum Raporu */}
          <Route path="/erp/rapor/e-arsiv-faturalari-durum" element={<ProtectedRoute user={user}><EArsivFaturalariDurumRaporu user={user} /></ProtectedRoute>} />
          {/* Depo Yönetimi Routes */}
          <Route 
            path="/erp/depo-yonetimi" 
            element={
              <ProtectedRoute user={user}>
                <DepoYonetimi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/depo-yonetimi/sayim" 
            element={
              <ProtectedRoute user={user}>
                <DepoSayim user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/depo-yonetimi/transfer" 
            element={
              <ProtectedRoute user={user}>
                <DepoTransfer user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/depo-yonetimi/envanter" 
            element={
              <ProtectedRoute user={user}>
                <DepoEnvanter user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/depo-yonetimi/raporlar" 
            element={
              <ProtectedRoute user={user}>
                <DepoRaporlar user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/erp/benim-menum" 
            element={
              <ProtectedRoute user={user}>
                <BenimMenu user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/api-logs" 
            element={
              <ProtectedRoute user={user}>
                <ApiLogs user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/destek-talebi" 
            element={
              <ProtectedRoute user={user}>
                <DestekTalebi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/ticket-listesi" 
            element={
              <ProtectedRoute user={user}>
                <TicketListesi user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/sayim-paneli" 
            element={
              <ProtectedRoute user={user}>
                <SayimPaneli user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/musteri-takip" 
            element={
              <ProtectedRoute user={user}>
                <MusteriTakip user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/musteri-takip-sistemi" 
            element={
              <ProtectedRoute user={user}>
                <MusteriTakipSistemi user={user} onLogout={handleLogout} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/siparisler" 
            element={
              <ProtectedRoute user={user}>
                <Siparisler user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/kara-liste" 
            element={
              <ProtectedRoute user={user}>
                <KaraListe user={user} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/musteri-iys" 
            element={
              <ProtectedRoute user={user}>
                <MusteriIYS user={user} />
              </ProtectedRoute>
            } 
          />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;